import { computed, onBeforeUnmount, onMounted, provide, ref } from "vue"
import { useFormContext } from "./useFormContext"
import { SectionIdInjectionKey } from "../types"
import type { SectionInfo } from "../types"

export interface UseFormSectionOptions {
  id: string
  title: string
  description?: string
}

export function useFormSection(options: UseFormSectionOptions): SectionInfo {
  const api = useFormContext()
  const el = ref<HTMLElement | null>(null)

  provide(SectionIdInjectionKey, options.id)

  const hasError = computed(() =>
    api.fields.value.some((f) => f.sectionId === options.id && f.error.value !== null)
  )

  const info: SectionInfo = {
    id: options.id,
    title: options.title,
    description: options.description,
    el,
    hasError
  }

  onMounted(() => api.registerSection(info))
  onBeforeUnmount(() => api.unregisterSection(options.id))

  return info
}
